import { ComponentType } from "react";
import { ButtonSlotProps } from "../types";

import styles from "./delete-confirmation-view.module.scss";

type DeleteConfirmationViewProps = {
  name: string;
  onCancel: () => void;
  onDelete: () => void;
  isDeleteLoading?: boolean;
  Button: ComponentType<ButtonSlotProps>;
};

// The destructive Delete action passes `tone="destructive"` to the Button slot.
// Consumer wrappers must render their Button so `tone="destructive"` triggers
// the destructive treatment in their package's local Button.
export const DeleteConfirmationView = ({
  name,
  onCancel,
  onDelete,
  isDeleteLoading,
  Button,
}: DeleteConfirmationViewProps) => (
  <>
    <h2 className={styles.modalContentHeader}>{`Delete ${name}?`}</h2>
    <p className={styles.deleteConfirmationDescription}>
      Warning, this action cannot be undone!
    </p>
    <div className={styles.deleteConfirmationButtons}>
      <Button
        onClick={onDelete}
        variant="primary"
        size="medium"
        tone="destructive"
        isFullWidth
        disabled={isDeleteLoading}
        loading={isDeleteLoading}
      >
        Delete
      </Button>
      <Button
        onClick={onCancel}
        variant="secondary"
        size="medium"
        isFullWidth
        disabled={isDeleteLoading}
      >
        Don’t delete
      </Button>
    </div>
  </>
);
